import API from '@/shared/plugins/Api/API'

class ModulesV1 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/applications/${encodeURIComponent(appName)}`
  }

  async list (appName) {
    const response = await this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/modules`
    })
    return response?.modules ?? response ?? {}
  }

  async install (appName, moduleName, version = 'latest') {
    await this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/modules/${encodeURIComponent(moduleName)}`,
      data: { version }
    })
  }

  async remove (appName, moduleName) {
    await this.request({
      method: 'delete',
      url: `${this._appUrl(appName)}/modules/${encodeURIComponent(moduleName)}`
    })
  }
}

export default ModulesV1
